import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.39 14.31c-.96-.71-.23-2.12.03-2.54-.47.52-.94 1.03-1.3 1.59-.57.88-.82 1.85-.43 2.47.7 1.12 2.37.6 3.43.15L21 11.81l-9.76 2.58c-.82.21-1.48.19-1.85-.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.57 4.5h4.44c1.654 0 3 1.346 3 3V9h-1.5V7.5c0-.826-.674-1.5-1.5-1.5h-3.82l-3.68 3.68c-.19.19-.402.348-.62.476l-.005.003L1.5 15.003V16.5c0 .826.674 1.5 1.5 1.5h18c.826 0 1.5-.674 1.5-1.5v-12H24v12c0 1.654-1.346 3-3 3H3c-1.654 0-3-1.346-3-3v-2.363l9.132-5.275c.121-.071.228-.153.318-.242l4.12-4.12z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.39 14.31c-.96-.71-.23-2.12.03-2.54-.47.52-.94 1.03-1.3 1.59-.57.88-.82 1.85-.43 2.47.7 1.12 2.37.6 3.43.15L21 11.81l-9.76 2.58c-.82.21-1.48.19-1.85-.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.57 4.5h4.44c1.654 0 3 1.346 3 3V9h-1.5V7.5c0-.826-.674-1.5-1.5-1.5h-3.82l-3.68 3.68c-.19.19-.402.348-.62.476l-.005.003L1.5 15.003V16.5c0 .826.674 1.5 1.5 1.5h18c.826 0 1.5-.674 1.5-1.5v-12H24v12c0 1.654-1.346 3-3 3H3c-1.654 0-3-1.346-3-3v-2.363l9.132-5.275c.121-.071.228-.153.318-.242l4.12-4.12z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.78 28.62c-1.92-1.42-.46-4.24.06-5.08-.94 1.04-1.88 2.06-2.6 3.18-1.14 1.76-1.64 3.7-.86 4.94 1.4 2.24 4.74 1.2 6.86.3L42 23.62l-19.52 5.16c-1.64.42-2.96.38-3.7-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M27.139 9h8.881c3.308 0 6 2.692 6 6v3h-3v-3c0-1.652-1.348-3-3-3h-7.639l-7.36 7.36c-.38.38-.804.696-1.24.953l-.01.006L3 30.006V33c0 1.652 1.348 3 3 3h36c1.652 0 3-1.348 3-3V9h3v24c0 3.308-2.692 6-6 6H6c-3.308 0-6-2.692-6-6v-4.726l18.264-10.55c.242-.143.457-.306.635-.485L27.14 9z",
    clipRule: "evenodd"
  }))
};
export var ShopSNKRS = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});